module.exports = __webpack_public_path__ + "img/view_compact.6458434e.svg";